import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { SelectorTypesEnum } from "../../../types/enums";
import { Input } from "../input/input";
import { SearchNormal } from "../../../images/exports";
import { getCaptionByType } from "../../../helpers/selectorFunctions";
import { Option } from './Option';
import './style.css';
export var Selector = function (_a) {
    var options = _a.options, selected = _a.selected, onSelect = _a.onSelect, _b = _a.units, units = _b === void 0 ? SelectorTypesEnum.SUM : _b, Layout = _a.Layout, _c = _a.showSearch, showSearch = _c === void 0 ? false : _c, _d = _a.label, label = _d === void 0 ? '' : _d;
    /**
     * Показывается ли выпадающий список
     */
    var _e = useState(false), isOptionsOpened = _e[0], setIsOptionsOpened = _e[1];
    /**
     * Значение поиска
     */
    var _f = useState(0), searchOption = _f[0], setSearchOption = _f[1];
    /**
     * Значения, которые будут находится в поиске
     */
    var _g = useState(options), filteredOptions = _g[0], setFilteredOption = _g[1];
    var selectorRef = useRef(null);
    // Закрытие при клике вне компонента
    useEffect(function () {
        var handleClickOutside = function (event) {
            if (selectorRef.current && !selectorRef.current.contains(event.target)) {
                setIsOptionsOpened(false);
                setSearchOption(0);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    useEffect(function () {
        var scrollArea = document.querySelector(".option-list");
        var selectedElement = document.querySelector(".select-button.selected");
        if (selectedElement && scrollArea) {
            scrollArea === null || scrollArea === void 0 ? void 0 : scrollArea.scrollTo(0, selectedElement.offsetTop - scrollArea.offsetTop);
        }
    }, [isOptionsOpened]);
    useEffect(function () {
        var roundedToThousand = Math.round(searchOption / 1000) * 1000;
        var roundedToHundreed = Math.round(searchOption / 100) * 100;
        if (typeof options[0] === "number" && typeof options[options.length - 1] === "number" && searchOption !== 0) {
            setFilteredOption(options.filter(function (option) {
                return option.toString().startsWith(searchOption.toString()) ||
                    option.toString().startsWith(roundedToHundreed.toString()) ||
                    option.toString().startsWith(roundedToThousand.toString()) ||
                    (roundedToThousand === 0) && option === 1000 ||
                    //@ts-ignore
                    (roundedToThousand > options[options.length - 1]) && option === options[options.length - 1];
            }));
        }
        else if (searchOption === 0) {
            setFilteredOption(options);
        }
    }, [searchOption, options]);
    var getSearchCaption = function () {
        switch (units) {
            case SelectorTypesEnum.SUM: {
                return 'Начните вводить сумму';
            }
            case SelectorTypesEnum.TERM: {
                return 'Начните вводить срок';
            }
            default:
                return 'Начните вводить';
        }
    };
    var handleOptionClick = function (option) {
        onSelect(option);
        setIsOptionsOpened(false);
        setSearchOption(0);
    };
    return (_jsxs("div", { className: "calc-selector", ref: selectorRef, children: [Layout &&
                _jsx(Layout, { isOptionsOpened: isOptionsOpened, selected: selected, setIsOptionsOpened: setIsOptionsOpened, setSearchOption: setSearchOption, units: units, label: label }), _jsx("section", { className: "select-options ".concat(isOptionsOpened ? 'opened' : ''), children: isOptionsOpened && (_jsxs(_Fragment, { children: [showSearch && (_jsxs("div", { className: 'calc-search', children: [_jsx(Input, { value: searchOption === 0 ? "" : searchOption, onChange: function (e) {
                                        // Проверяем, что введены только цифры (без + или -)
                                        if (/^\d*$/.test(e.target.value) && (e.target.value === '' || (
                                        // Проверяем, что введенное значение не превышает максимальную опцию более чем на 1 символ
                                        Number(e.target.value) <= options[options.length - 1] ||
                                            e.target.value.length <= String(options[options.length - 1]).length + 1))) {
                                            setSearchOption(Number(e.target.value));
                                        }
                                    }, type: 'text', variant: 'outlined', placeholder: getSearchCaption() }), _jsx(SearchNormal, { className: 'search-icon' })] })), filteredOptions.length !== 0 &&
                            _jsx("div", { className: 'option-list', children: filteredOptions.map(function (option, index) { return (_jsx(Option, { option: option, selected: selected === option, onSelect: handleOptionClick, caption: getCaptionByType(option, units) }, index)); }) }), filteredOptions.length === 0 && (_jsx("p", { children: "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E" }))] })) })] }));
};
